export default "__VITE_ASSET__BEahLk8F__"